import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'

import withRoles from 'containers/Role/Project/index'
import Layout from './Layout'

import {
  MODULE_NAME,
} from './constants'

import {
  workflowIdSelector,
  projectIdSelector,
} from 'containers/Project/View/selectors'

import {
  redirectSelector,
} from './selectors'

import {
  submit,
  mount,
  unmount
} from './actions'

import {
  watchSubmit as saga
} from './sagas'

import {
  setFormStatus
} from 'containers/Project/actions'

const mapStateToProps = (state) => {
  return {
    projectId: projectIdSelector(state),
    workflowId: workflowIdSelector(state),
    redirect: redirectSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSave: (projectId, workflowId) => dispatch(submit(projectId, workflowId)),
    setFormStatus: (status) => dispatch(setFormStatus(status)),
    unmount: () => dispatch(unmount()),
    mount: () => dispatch(mount()),
  }
}

class ProjectReview extends Component {
  componentWillMount() {
    this.props.mount()
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  onSave = () => {
    const { onSave, projectId, workflowId } = this.props
    this.props.onSave(projectId, workflowId)
  }

  render() {
    return (
      <Layout
        id={this.props.match.params.id}
        onSubmit={this.onSave}
        setFormStatus={this.props.setFormStatus}
        redirect={this.props.redirect}
      />
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: saga })
const enhance = compose(
  withSagas,
  withConnect
)

export default enhance(ProjectReview)
